import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { FacebookFormsTableService } from './facebook-forms-table.service';
import { FacebookLeadAdsFormAutomationConfigurationService } from './fb-forms-automation-configuration.service';

@Component({
  selector: 'app-facebook-forms-table',
  templateUrl: './fb-forms-table.component.html',
  styleUrls: ['./fb-forms-table.component.scss'],
  standalone: false,
})
export class FacebookFormsTableComponent implements OnInit, OnDestroy {
  @Input() facebookPageID$: Observable<string>;
  facebookPageIDSubscription: Subscription;

  showAlert$: Observable<boolean>;

  constructor(
    readonly facebookFormsTableService: FacebookFormsTableService,
    private dataService: FacebookLeadAdsFormAutomationConfigurationService,
  ) {}

  ngOnInit(): void {
    this.facebookPageIDSubscription = this.facebookPageID$
      .pipe(filter((pageID) => pageID !== ''))
      .subscribe((pageID) => {
        this.dataService.loadFacebookForms(pageID);
      });

    this.showAlert$ = this.facebookFormsTableService.showAlert$;
  }

  ngOnDestroy(): void {
    if (this.facebookPageIDSubscription) {
      this.facebookPageIDSubscription.unsubscribe();
    }
  }
}
